import { Brand } from '../effect';

export const makeTimezoneShortcode = Brand.nominal<TimezoneShortcode>();

// Unfortunately this needs to be nullable since we can't guarantee that the date/tz will be valid
export const getTimezoneShortcode = (date: DateTimeISOString, tz: IanaTimezone): MaybeUndefined<TimezoneShortcode> => {
  const shortcode = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    timeZoneName: 'short',
  })
    .formatToParts(new Date(date))
    .find((part) => part.type === 'timeZoneName')?.value;

  return shortcode ? makeTimezoneShortcode(shortcode) : undefined;
};
